/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminRedriveStuckFlowRunsResponse
 */
export interface AdminRedriveStuckFlowRunsResponse {
    /**
     * 
     */
    count: number;
    /**
     * 
     */
    runIds: Array<string>;
    /**
     * 
     */
    dryRun: boolean;
}

/**
 * Check if a given object implements the AdminRedriveStuckFlowRunsResponse interface.
 */
export function instanceOfAdminRedriveStuckFlowRunsResponse(value: object): value is AdminRedriveStuckFlowRunsResponse {
    if (!('count' in value) || value['count'] === undefined) return false;
    if ((!('runIds' in (value as Record<string, any>)) && !('run_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['runIds'] === undefined && (value as Record<string, any>)['run_ids'] === undefined)) return false;
    if ((!('dryRun' in (value as Record<string, any>)) && !('dry_run' in (value as Record<string, any>))) || ((value as Record<string, any>)['dryRun'] === undefined && (value as Record<string, any>)['dry_run'] === undefined)) return false;
    return true;
}

export function AdminRedriveStuckFlowRunsResponseFromJSON(json: any): AdminRedriveStuckFlowRunsResponse {
    return AdminRedriveStuckFlowRunsResponseFromJSONTyped(json, false);
}

export function AdminRedriveStuckFlowRunsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminRedriveStuckFlowRunsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'runIds': json['run_ids'],
        'dryRun': json['dry_run'],
    };
}

export function AdminRedriveStuckFlowRunsResponseToJSON(json: any): AdminRedriveStuckFlowRunsResponse {
    return AdminRedriveStuckFlowRunsResponseToJSONTyped(json, false);
}

export function AdminRedriveStuckFlowRunsResponseToJSONTyped(value?: AdminRedriveStuckFlowRunsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'run_ids': value['runIds'],
        'dry_run': value['dryRun'],
    };
}

